import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const Invoice = () => {
  const [orderData, setOrderData] = useState(null);
  const { order_id } = useParams();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;



  useEffect(() => {
    const fetchOrderDetails = async () => {
      try {
        const response = await axios.post(`${API_BASE_URL}print_detail.php`,
          { order_id }
        );

        if (response.data.head.code === 200) {
          setOrderData(response.data.body);
          console.log(response.data.body)
        } else {
          console.error("Failed to fetch order details");
        }
      } catch (err) {
        console.error("Error fetching data");
      }
    };

    fetchOrderDetails();
  }, []);


  const bill_detail = orderData?.bill_detail || [];
  const final_billing = orderData?.final_billing || [];


  // Calculate bottom section totals
  let totalAmount = 0;

  bill_detail.forEach((item) => {
    totalAmount += parseFloat(item.total_per_product) || 0;

  });

  let taxSummary = {};

  final_billing.forEach((item) => {
    Object.keys(item).forEach((taxKey) => {
      if (item[taxKey] && typeof item[taxKey] === "object") {
        const gstRate = parseInt(taxKey.replace("tax", ""), 10); // Extract tax percentage (e.g., 12 from "tax12")

        if (!taxSummary[gstRate]) {
          taxSummary[gstRate] = {
            taxableValue: "",
            cgst: 0,
            sgst: 0,
            totalTax: "",
          };
        }

        taxSummary[gstRate].taxableValue += item[taxKey].without_gst || 0;
        taxSummary[gstRate].cgst += (item[taxKey].gst_amt || 0) / 2;
        taxSummary[gstRate].sgst += (item[taxKey].gst_amt || 0) / 2;
        taxSummary[gstRate].totalTax += item[taxKey].gst_amt || 0;
      }
    });
  });

  const numberToWords = (num) => {
    if (num === 0) return "Zero";

    const ones = [
      "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
      "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen",
      "Seventeen", "Eighteen", "Nineteen"
    ];
    const tens = [
      "", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"
    ];

    const convertBelowThousand = (n) => {
      if (n < 20) return ones[n];
      if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 !== 0 ? " " + ones[n % 10] : "");
      return ones[Math.floor(n / 100)] + " Hundred" + (n % 100 !== 0 ? " and " + convertBelowThousand(n % 100) : "");
    };

    let integerPart = Math.floor(num); // Rupees
    let decimalPart = Math.round((num - integerPart) * 100); // Paise

    let result = "";

    // Convert Rupees
    if (integerPart > 0) {
      let crores = Math.floor(integerPart / 10000000);
      let lakhs = Math.floor((integerPart % 10000000) / 100000);
      let thousands = Math.floor((integerPart % 100000) / 1000);
      let hundreds = integerPart % 1000;

      if (crores) result += convertBelowThousand(crores) + " Crore ";
      if (lakhs) result += convertBelowThousand(lakhs) + " Lakh ";
      if (thousands) result += convertBelowThousand(thousands) + " Thousand ";
      if (hundreds) result += convertBelowThousand(hundreds);
    } else {
      result = "Zero";
    }

    result = result.trim();

    // Convert Paise if present
    if (decimalPart > 0) {
      result += ` and ${convertBelowThousand(decimalPart)} Paise`;
    }

    return result + " Only";
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      window.print();
    }, 2000); // 2-second delay

    return () => clearTimeout(timer); // Cleanup the timeout on unmount
  }, []);




  return (



    <div className="invoice-container" style={{
      width: "100%",
      maxWidth: "100%",
      margin: "auto",
      padding: "10px",
      fontFamily: "Arial, sans-serif",
      // overflowX: "auto"
    }}>

      <h2 style={{ textAlign: "center", marginBottom: "10px", color: "black" }}>Tax Invoice</h2>
      <div style={{ display: "flex", justifyContent: "space-between", borderBottom: "1px solid black", paddingBottom: "10px" }}>
        <div>
          {orderData && orderData.seller_detail && (
            <>
              <strong>{orderData.seller_detail.shop_name}</strong>,
              <br />
              <strong>{orderData.seller_detail.gst_no}</strong>,
              <br />
              {orderData.seller_detail.address}
              <br />
              {orderData.seller_detail.city}
              <br />
              {orderData.seller_detail.state} - {orderData.seller_detail.pincode}
              <br />
              {orderData.seller_detail.phone}
              <br />

            </>
          )}
        </div>

        {orderData ? (
          <div>
            <strong>Invoice No:</strong> {orderData.order_id}
            <br />
            <strong>Dated:</strong> {orderData.order_date}
          </div>
        ) : (
          <p> </p>
        )}

      </div>
      <div style={{ marginTop: "10px", borderBottom: "1px solid black", paddingBottom: "10px" }}>
        {orderData && orderData.buyer_detail && (
          <>
            <strong>Buyer (Bill to)</strong><br />
            <strong>{orderData.buyer_detail.name}</strong>,
            <br />
            {orderData.buyer_detail.tax_number}
            <br />
            {orderData.buyer_detail.address}
            <br />
            {orderData.buyer_detail.telephone}
            <br />

          </>
        )}
      </div>

      <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "10px" }}>
        <thead>
          <tr>
            <th style={{ border: "1px solid black", padding: "5px" }}>S No</th>
            <th style={{ border: "1px solid black", padding: "5px" }}>Description of Goods</th>
            <th style={{ border: "1px solid black", padding: "5px" }}>HSN/SAC</th>
            <th style={{ border: "1px solid black", padding: "5px" }}>GST Rate</th>
            <th style={{ border: "1px solid black", padding: "5px" }}>Quantity</th>
            <th style={{ border: "1px solid black", padding: "5px", textAlign: "right" }}>Rate (Incl. of Tax)</th>
            <th style={{ border: "1px solid black", padding: "5px", textAlign: "right" }}>Amount</th>
          </tr>
        </thead>
        <tbody>
          {orderData && orderData.bill_detail ? (
            orderData.bill_detail.map((item, index) => (
              <tr key={index}>
                <td style={{ border: "1px solid black", padding: "5px" }}>{index + 1}</td>
                <td style={{ border: "1px solid black", padding: "5px" }}>{item.product_name}</td>
                <td style={{ border: "1px solid black", padding: "5px" }}>{item.hsn_code}</td>
                <td style={{ border: "1px solid black", padding: "5px" }}>{item.tax_percentage}%</td>
                <td style={{ border: "1px solid black", padding: "5px" }}>{item.qty} - {item.unit}</td>
                <td style={{ border: "1px solid black", padding: "5px", textAlign: "right" }}>$ {Number(item.amount_per_product || 0).toFixed(2)}</td>
                <td align="right" style={{ border: "1px solid black", padding: "5px", textAlign: "right" }}>
                  $ {Number(item.total_per_product || 0).toFixed(2)}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="7" style={{ textAlign: "center", padding: "10px" }}>Loading...</td>
            </tr>
          )}
        </tbody>

      </table>
      <div style={{ textAlign: "right", marginTop: "10px", color: "black" }}>
        {/* <strong> Sub Total: &nbsp; </strong><strong>  Rs. {orderData.subtotal}</strong> */}
        {/* <strong> Tax: &nbsp; </strong><strong>  Rs. {orderData.cgst_amt * 2}</strong> */}
        <strong> Total: &nbsp; </strong><strong>  $ {totalAmount.toFixed(2)}</strong>
        
      </div>
      <div style={{ borderTop: "1px solid black", marginTop: "10px", paddingTop: "10px" }}>
        {/* <strong>Amount Chargeable (in words):</strong> Indian Rupees {numberToWords(totalAmount)} */}
        <strong>Amount Chargeable (in words):</strong> {numberToWords(totalAmount)}
      </div>
      {/* <div style={{ borderTop: "1px solid black", marginTop: "10px", paddingTop: "10px" }}>
        <strong>Tax Details:</strong>
        <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "10px" }}>
          <thead>
            <tr>
              <th style={{ border: "1px solid black", padding: "5px", textAlign: "right" }}>Taxable Value</th>
              <th style={{ border: "1px solid black", padding: "5px" }}>CGST(%)</th>
              <th style={{ border: "1px solid black", padding: "5px", textAlign: "right" }}>CGST</th>
              <th style={{ border: "1px solid black", padding: "5px" }}>SGST(%)</th>
              <th style={{ border: "1px solid black", padding: "5px", textAlign: "right" }}>SGST</th>
              <th style={{ border: "1px solid black", padding: "5px", textAlign: "right" }}>Total Tax</th>
            </tr>
          </thead>
          <tbody>
            {Object.keys(taxSummary).map((taxRate) => (
              <tr key={taxRate}>
                <td style={{ border: "1px solid black", padding: "5px", textAlign: "right" }}>
                  {parseFloat(taxSummary[taxRate].taxableValue).toFixed(2)}
                </td>
                <td style={{ border: "1px solid black", padding: "5px" }}>{(taxRate / 2)}%</td>
                <td style={{ border: "1px solid black", padding: "5px", textAlign: "right" }}>
                  {parseFloat(taxSummary[taxRate].cgst).toFixed(2)}
                </td>
                <td style={{ border: "1px solid black", padding: "5px" }}>{(taxRate / 2)}%</td>
                <td style={{ border: "1px solid black", padding: "5px", textAlign: "right" }}>
                  {parseFloat(taxSummary[taxRate].sgst).toFixed(2)}
                </td>
                <td style={{ border: "1px solid black", padding: "5px", textAlign: "right" }}>
                  {parseFloat(taxSummary[taxRate].totalTax).toFixed(2)}
                </td>
              </tr>
            ))}

           
            <tr>
              <th style={{ border: "1px solid black", padding: "5px", textAlign: "right" }}>
                Total :&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  {Object.values(taxSummary)
                  .reduce((acc, item) => acc + parseFloat(item.taxableValue || 0), 0)
                  .toFixed(2)}
              </th>
              <th style={{ border: "1px solid black", padding: "5px" }}>-</th>
              <th style={{ border: "1px solid black", padding: "5px", textAlign: "right" }}>
                {Object.values(taxSummary)
                  .reduce((acc, item) => acc + parseFloat(item.cgst || 0), 0)
                  .toFixed(2)}
              </th>
              <th style={{ border: "1px solid black", padding: "5px" }}>-</th>
              <th style={{ border: "1px solid black", padding: "5px", textAlign: "right" }}>
                {Object.values(taxSummary)
                  .reduce((acc, item) => acc + parseFloat(item.sgst || 0), 0)
                  .toFixed(2)}
              </th>
              <th style={{ border: "1px solid black", padding: "5px", textAlign: "right" }}>
                {Object.values(taxSummary)
                  .reduce((acc, item) => acc + parseFloat(item.totalTax || 0), 0)
                  .toFixed(2)}
              </th>
            </tr>
          </tbody>

        </table>

      </div> */}
      {/* <div style={{ borderTop: "1px solid black", marginTop: "10px", paddingTop: "10px" }}>
        Tax Amount (in words) : <strong>Indian Rupees Seven Thousand Nine Hundred Twenty Two Only</strong>
      </div> */}
      <div style={{ textAlign: "left", marginTop: "20px" }}>
        Company's PAN :  <strong>ALVPS4061P</strong>
      </div>
      <div style={{ textAlign: "left", marginTop: "5px", width: "50%" }}>
        <strong style={{ borderBottom: "1px solid" }}>Declaration</strong><br />
        <p><b>We declare that this invoice  shows the</b> </p>
        <p style={{ fontSize: "10px" }}> actual price of the goods described and that all particulars are true and correct.</p>
      </div>
      <div style={{ textAlign: "right", marginTop: "-40px" }}>
        <strong >Authorized Signatory</strong>
      </div>
    </div>
  );
};

export default Invoice; 